export type CmsBoolean = 'true' | 'false' | '' | undefined;

export function parseCmsBoolean(value: CmsBoolean): boolean {
  return value === 'true';
}
